import minimatch from 'minimatch';

import env from '#shared/config/env.js';
import { escapeMarkup } from '#shared/util/sanitizer.js';

import { getRequestHostname, getRequestOrigin, getRequestPath } from '#backend/util/request.js';

/**
 * URL schema
 * @param {object} data
 * @param {object} data.route
 * @param {object} data.store
 * @param {object} data.location (CLIENT ONLY)
 * @param {object} data.response (SERVER ONLY)
 * @param {object} data.request (SERVER ONLY)
 * @returns {object}
 */
export const urlSchema = ({ route, store, location, response, request }) => {
	// Remove non-whitelisted or blacklisted parameters and escape remaining
	const escapedQueryEntries = Object.entries(route.query).filter(([key]) => {
		const blacklisted = env.blacklist.some((pattern) => minimatch(key, pattern));
		const whitelisted = env.whitelist.some((pattern) => minimatch(key, pattern));
		return whitelisted && !blacklisted;
	}).map(([key, value]) => [key, escapeMarkup(value)]);
	// Create query object in expected format
	const modifiedQueryObject = escapedQueryEntries.reduce((previous, [key, value = '']) => {
		const valueString = Array.isArray(value) ? value.join(',') : String(value);
		const valueArray = Array.isArray(value) ? value : valueString.split(',');
		previous[key] = {
			array: valueArray,
			string: valueString,
			cssString: `-${valueString.toLowerCase().replaceAll('-', '').replaceAll(',', ' -')}`
		};
		return previous;
	}, {});
	// Create query string in expected format
	const modifiedQueryString = Object.entries(modifiedQueryObject)
		.map(([key, value]) => `${key}=${value.string}`)
		.join('&');
	// Create url schema object
	const data = {
		query: modifiedQueryObject
	};
	if (IS_SERVER) {
		data.env = env.providersEnvironment;
		data.brand = response.locals.brandName;
		data.theme = response.locals.themeName;
		data.locale = response.locals.locale;
		data.language = response.locals.language;
		data.region = response.locals.region;
		data.hostname = getRequestHostname(request);
		data.origin = getRequestOrigin(request);
		data.pathname = getRequestPath(request);
		data.protocol = request.protocol.replace(':', '');
		data.hash = null; // Browser not sent hash into BE
	}
	if (IS_CLIENT) {
		data.hostname = location.hostname;
		data.origin = location.origin;
		data.pathname = location.pathname;
		data.protocol = location.protocol.replace(':', '');
		data.hash = location.hash;
	}
	// Add url href property with modified query string
	data.href = `${data.origin}${data.pathname}?${modifiedQueryString}`;
	return {
		...store.state.url,
		...data
	};
};
